/**
 * LWcustom - Modify this array to include any models that have special display names
 */
export const customTitles = [
  {
    original: "template_custom_title",
    display: "Template Custom Title",
  },
  {
    original: "moment",
    display: "Moment",
  },
  {
    original: "landmark",
    display: "Landmark",
  },
];

export interface IDropdownOption {
  label?: string;
  value: string | number;
}

export interface IDropdownMapping {
  model: string;
  field: string;
  options: IDropdownOption[];
}

/**
 * Custom dropdown options. Forms will intercept these models and fields to add dropdown options to them
 */
export const dropdownFields = [
  {
    model: "model_name",
    field: "fieldName or column_name",
    options: [
      { label: "what shows on the dropdown", value: "optionValue" },
      { label: "label", value: "value" },
    ],
  },
  {
    model: "media",
    field: "media_type",
    options: [
      { label: "Image", value: "image" },
      { label: "Video", value: "video" },
    ],
  },
  {
    model: "users",
    field: "user_role",
    options: [
      { label: "Admin", value: "admin" },
      { label: "User", value: "user" },
    ],
  },
];

interface ICustomField {
  original: string;
  display?: string;
  hint?: string;
  optional?: boolean;
  accept?: string;
  modelSpecific?: ICustomFieldModelSpecific[];
  hide?: boolean;
}

interface ICustomFieldModelSpecific {
  modelName: string;
  display?: string;
  hint?: string;
  accept?: string;
  optional?: boolean;
  hide?: boolean;
}

/**
 * LWcustom - Modify this array to include model fields that have custom display names and hints on their forms
 */
export const customFieldNames: ICustomField[] = [
  {
    original: "template_custom_item",
    display: "Template Custom Item",
    hint: "Hints for fields",
    modelSpecific: [
      {
        modelName: "model_name",
        display: "This model's field will be displayed as this name",
        hint: "This model will get this hint",
      },
    ],
  },
  {
    original: "dateDataVisibility",
    display: "Date Data Visibility",
  },
  {
    original: "popularMomentListVisibility",
    display: "Popular Moments Visibility",
  },
  {
    original: "timeoutDuration",
    display: "Timeout (Moments)",
    hint: "Number of seconds of inactivity before the Defining Moments Wall reverts to a screensaver",
  },
  {
    original: "mfa_enabled",
    display: "Enable MFA",
    hint: "Enable Multi-factor authentication for this user. Modifying this value for yourself will require you to sign in again.",
  },
  {
    original: "mfa_verified",
    display: "MFA Verified",
  },
  {
    original: "place",
    display: "Places",
    modelSpecific: [
      {
        modelName: "moment",
        hint: "Click to add a place",
      },
    ],
  },
  {
    original: "topics",
    display: "Topics",
    modelSpecific: [
      {
        modelName: "moment",
        hint: "Click to add a topic",
      },
    ],
  },
  {
    original: "title",
    hint: "Max 15 words",
    optional: false,
  },
  {
    original: "date",
    hint: "Preferably a number; max. 5 words",
    optional: false,
  },
  {
    original: "description",
    hint: "Max. 100 words",
  },
  {
    original: "thumbnail",
    modelSpecific: [
      {
        modelName: "moment",
        hint: "Square 400 x 400px; if no thumbnail provided then the first image for this moment will be auto cropped",
      },
    ],
  },
  {
    original: "promoted",
    hint: "Make this moment more prominent on the timeline",
  },
  {
    original: "marked_as_new",
    hint: "Mark this moment as new on the timeline",
  },
  {
    original: "hidden",
    hint: "Show and hide this moment on the timeline",
  },
  {
    original: "date_optional",
    display: "Optional date",
    hint: "Enter a short version of the moment date for the timeline thumbnail",
  },
  {
    original: "thumb_title_optional",
    display: "Optional thumbnail title",
    hint: "Enter a short version of the moment title for the timeline thumbnail",
  },
  {
    original: "image",
    modelSpecific: [
      {
        modelName: "media",
        hint: "Images must be .png or .jpeg, at least 1920px on the long edge",
        optional: false,
      },
    ],
  },
  {
    original: "video",
    modelSpecific: [
      {
        modelName: "media",
        hint: "Videos must be H.264 .mp4, 25fps, CBR, 22mbps",
        optional: false,
      },
    ],
  },
  {
    original: "media_title_image",
    hint: "Used as intros for video; .png or .jpeg at least 600px wide",
  },
  {
    original: "caption",
    hint: "Max 15-20 words",
    modelSpecific: [
      {
        modelName: "media",
        optional: false,
      },
    ],
  },
  {
    original: "object_location",
    hint: "Where the object is located at NMA - e.g. 'Journeys gallery'",
  },
  {
    original: "subtitles",
    hint: "Upload subtitles for videos; .srt files",
  },
  {
    original: "silent_video",
    hint: "Mark this media as a silent video",
  },
  {
    original: "name",
    optional: false,
  },
  {
    original: "email",
    optional: false,
  },
  {
    original: "user_role",
    optional: false,
  },
  {
    original: "landmarksTimeout",
    display: "Timeout (Landmarks)",
    hint: "Number of seconds of inactivity before Landmarks gallery closes active popups",
  },
  {
    original: "media_type",
    optional: false,
  },
];
